<script setup lang="ts">
import { useDisplay } from 'vuetify';
import { useSideBar } from '../composables/useSideBar';

const { smAndDown } = useDisplay();
const { sideBarOpen, selectedEntity, sideBarWidth } = useSideBar();
</script>

<template>
  <v-navigation-drawer
    v-if="selectedEntity"
    v-model="sideBarOpen"
    :class="smAndDown ? 'bg-surface border-0' : 'bg-surface-container-lowest'"
    name="control-panel-light-side-bar"
    :permanent="!smAndDown"
    :absolute="smAndDown"
    location="right"
    :width="sideBarWidth"
    disable-resize-watcher
    :mobile="null"
    :mobile-breakpoint="0"
  >
    <slot name="content"></slot>
  </v-navigation-drawer>
</template>
